import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export function getPdf(title, dom, emptyDomId) {
    // 注册getPdf方法，传入两个参数，此处使用了promise处理导出后的操作
    /*
    title: 导出文件名
    dom: 需要导出dom的id
     */
    return new Promise((resolve, reject) => {
        // 1. 先隐藏所有 class="project" 的元素
        const projectElements = document.querySelectorAll('.project');
        const originalDisplayValues = [];

        projectElements.forEach(el => {
            originalDisplayValues.push(el.style.display); // 保存原始 display 值
            el.style.display = 'none'; // 隐藏元素
        });
        html2Canvas(dom, {
            useCORS: true, // 由于打印时，会访问dom上的一些图片等资源，解决跨域问题！！重要
            scale: 2, // 提高缩放比例
            logging: true, // 开启日志查看问题
            allowTaint: true // 允许跨域
        }).then(canvas => {
            const contentWidth = canvas.width
            const contentHeight = canvas.height
            // 根据A4纸的大小，计算出dom相应比例的尺寸
            const pageHeight = contentWidth / 592.28 * 841.89
            let leftHeight = contentHeight
            let position = 0
            const imgWidth = 595.28
            // 根据a4比例计算出需要分割的实际dom位置
            const imgHeight = 592.28 / contentWidth * contentHeight
            // canvas绘图生成image数据，1.0是质量参数
            const pageData = canvas.toDataURL('image/jpeg', 0.92)
            // a4大小
            const PDF = new JsPDF('', 'pt', 'a4')
            // 当内容达到a4纸的高度时，分割，将一整块画幅分割出一页页的a4大小，导出pdf
            if (leftHeight < pageHeight) {
                PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
            } else {
                while (leftHeight > 0) {
                    PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                    leftHeight -= pageHeight
                    position -= 841.89
                    if (leftHeight > 0) {
                        PDF.addPage()
                    }
                }
            }
            // 导出
            PDF.save(title + '.pdf')
            // 删除添加的空div
            // 3. 截图完成后，恢复 project 元素的显示状态
            projectElements.forEach((el, index) => {
                el.style.display = originalDisplayValues[index] || ''; // 恢复原始 display
            });
            const emptyDom = document.getElementById(emptyDomId)
            if (emptyDom && emptyDom.parentNode) {
                emptyDom.parentNode.removeChild(emptyDom)
            }
            resolve(true)
        })
            .catch((err) => {
                // 3. 截图完成后，恢复 project 元素的显示状态
                projectElements.forEach((el, index) => {
                    el.style.display = originalDisplayValues[index] || ''; // 恢复原始 display
                });
                reject(err || false)
            })
    })
}
